import classNames from 'classnames';
import React, { useMemo } from 'react';
import { type RewindsStillStoryboard } from 'utils/rewinds/previewStills';
import StoryboardImage from './StoryboardImage';
import styles from './CamPlayerPreviewImage.module.scss';

const CamPlayerPreviewImage = ({ storyboards }: { storyboards: RewindsStillStoryboard[] }) => {
  /*
  We render all storyboard qualities at once. We'll always start with the lowest quality
  and work our way up. Once the images have been loaded once they are cached locally so
  they will load again very quality and almost immediately show the highest quality image
  on a re-render. This approach eliminates a flicker in the UI when scrubbing fast.
  */
  const shouldRenderPreview = storyboards.length > 0;

  const fullSizeStills = useMemo(
    () => (
      <div
        className={classNames({
          [styles.storyboardContainerFullScreen]: true,
          [styles.hidden]: !shouldRenderPreview,
        })}
        data-testid="kbyg-rewinds-preview-image-full-size"
      >
        {storyboards.map((storyboard, index) => (
          <StoryboardImage key={`storyboard_${index + 1}_full`} storyboard={storyboard} />
        ))}
      </div>
    ),
    [shouldRenderPreview, storyboards],
  );

  return fullSizeStills;
};

export default CamPlayerPreviewImage;
